const klaviyo = window.klaviyo || [];

klaviyo.init({
  account: "SuVvWa",
  list: "UP7uEF",
  platform: "shopify"
});

klaviyo.enable("backinstock", { 
  trigger: {
    product_page_text: "Notify Me When In Stock",
    product_page_class: "product-form__submit-disabled product-form__submit button button--full-width",
    product_page_text_align: "center",
    product_page_margin: "",
    replace_anchor: true
  },
  modal: {
    headline: "{product_name}",
    body_content: "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email Address",
    button_label: "Notify me when available",
    newsletter_subscribe_label: "Add me to your email list.",
    subscription_success_label: "You're in! We'll let you know when it's back in stock.", 
    footer_content: "",
    additional_styles: (` 
      * { 
        font-family: Arial !important;
      }

      #container {
        padding-top: 30px !important;
        margin-top: 150px;
      }
      
      .btn { 
        text-transform: uppercase;
        font-weight: bold;
      }

      .modal-title {
        font-weight: bold;
      }

      .form-group {
        margin-bottom: 0;
      }

      .form-control {
        box-shadow: none;
      }
    `),
    drop_background_color: "#FFFFFF",
    background_color: "#FFFFFF",
    text_color: "#000000",
    button_text_color: "#FFFFFF",
    button_background_color: "#003E6E",
    close_button_color: "#CCCCCC",
    error_background_color: "#FFC3B8",
    error_text_color: "#D82C0D",
    success_background_color: "#EAF7EE",
    success_text_color: "#0B5D1E"
  }
});